import {_Sitemap} from "@localization/siteMap/breadcrumbs/_Sitemap.ts";
import {HomeOutlined} from "@mui/icons-material";
import {Chip, Grid, Paper, Typography} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {Link as RouterLink} from "react-router";
import React from "react";

export const PageNotFound: React.FC = () => {

    return (
        <DefaultContainer titulo={'Eita!! 404 - Pagina não encontrada encontrada'} component={Paper}>
            <Grid container justifyContent={'center'}>
                <Grid size={12}>
                    <Typography align={'center'} variant={'subtitle2'}>Desculpe, a página que você está procurando não
                        existe</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography align={'center'} variant={'subtitle2'}>É recomendável voltar para a
                        <Chip label={'Pagina inicial'}
                              component={RouterLink}
                              sx={{ml: 0.5}}
                              clickable
                              size={'small'}
                              deleteIcon={<HomeOutlined/>}
                              onDelete={() => {
                              }}
                              to={_Sitemap.home.fullUrl}/>
                    </Typography>
                </Grid>
            </Grid>
        </DefaultContainer>
    );
}